import { render, staticRenderFns } from "./ShoppingOverview.vue?vue&type=template&id=fbc094f0&scoped=true&"
import script from "./ShoppingOverview.vue?vue&type=script&lang=js&"
export * from "./ShoppingOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbc094f0",
  null
  
)

export default component.exports